import { createQueryKeyStore } from "@lukemorales/query-key-factory";

import type { UseGetPharmacyAcceptCodeBoardsQueryArgs } from "../hooks/bffPharmacyAcceptCodeBoard/useGetPharmacyAcceptCodeBoardsQuery";

export const bffPharmacyAcceptCodeBoardKeys = createQueryKeyStore({
  acceptCodeBoards: {
    detail: (args: UseGetPharmacyAcceptCodeBoardsQueryArgs) => [args],
  },
});
